import Notification, { NotificationType } from "./Notification";
import { OptionsObject, SnackbarKey, SnackbarMessage } from "notistack";

export default class NotificationDispatcher {
    private enqueue?: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey;

    readonly dispatchSuccess = (message: string): void => {
        this.dispatch({
            type: NotificationType.SUCCESS,
            message
        });
    }

    readonly dispatchError = (message: string): void => {
        this.dispatch({
            type: NotificationType.ERROR,
            message
        });
    }

    readonly dispatchInfo = (message: string): void => {
        this.dispatch({
            type: NotificationType.INFO,
            message
        });
    }

    readonly dispatchWarning = (message: string): void => {
        this.dispatch({
            type: NotificationType.WARNING,
            message
        });
    }

    readonly dispatch = (notification: Notification): void => {
        if (!this.enqueue) {
            console.warn('Notification Dispatcher: enqueue function not set')
            return;
        }

        this.enqueue(
            notification.message,
            { variant: notification.type }
        );
    }

    readonly setEnqueue = (fn: (message: SnackbarMessage, options?: OptionsObject) => SnackbarKey): void => {
        if (this.enqueue) {
            console.warn('Notification Dispatcher: enqueue function already set');
            return;
        }

        this.enqueue = fn;
    }
}
